import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
const env = import.meta.env.VITE_ENV || 'development';

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase environment variables');
}

/**
 * Determine which schema to use based on environment
 * - production: public schema
 * - testing/development: testing schema
 */
export const getSchema = (): 'public' | 'testing' => {
  return env === 'production' ? 'public' : 'testing';
};

/**
 * Check if we're using testing tables
 */
export const isUsingTestingSchema = (): boolean => {
  return getSchema() === 'testing';
};

/**
 * Get the full table name with schema prefix
 * For RPC calls and raw queries that need schema specification
 */
export const getTableName = (tableName: string): string => {
  const schema = getSchema();
  // For the testing schema, we prefix the table name
  // For public schema, we can use just the table name (it's the default)
  return schema === 'testing' ? `testing.${tableName}` : tableName;
};

/**
 * Get the full view name with schema prefix
 */
export const getViewName = (viewName: string): string => {
  const schema = getSchema();
  return schema === 'testing' ? `testing.${viewName}` : viewName;
};

/**
 * Create Supabase client with schema configuration
 */
export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '', {
  db: {
    schema: getSchema(),
  },
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
});

// Log which schema is being used (helpful for debugging)
if (typeof window !== 'undefined') {
  // console.log(`[Supabase] Environment: ${env}, Schema: ${getSchema()}`);
}